module.exports = __webpack_public_path__ + "static/media/plat1.cf0109b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/food/plat1.jpg
// module id = 551
// module chunks = 0